export default class DialogButtons {
  static readonly Yes = "yes";
  static readonly No = "no";
  static readonly Ok = `ok`;
  static readonly Cancel = `cancel`;
  static readonly Close = `close`;
}
